import { connect } from 'react-redux';
import View from './WhatIfsView';
import {
  visible,
  open,
  currentViewIdSelector,
  nullableFpIdSelector,
  hasShellSelector,
} from './WhatIfsSelector';
import {
  goalId as goalIdSelector,
  selectedGoalSelector,
} from '../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { setCurrentViewId, resetModelPortfoliosGroups } from './WhatIfsActions';
import { selectedInsuranceTypeOrDefaultSelector } from '../FinancialPlan/Insurance/InsuranceSelector';
import { selectFeatureFlags } from '../CommonSelectors/CommonAreaSelector';
import { isFeatureEnabled } from '../_hooks/useFeatureFlag';

const mapStateToProps = (state, ownProps) => ({
  visible: visible(state, ownProps),
  open: open(state, ownProps),
  currentView: currentViewIdSelector(state, ownProps),
  fpId: nullableFpIdSelector(state, ownProps),
  goalId: goalIdSelector(state, ownProps),
  hasShell: hasShellSelector(state, ownProps),
  selectedInsuranceType: selectedInsuranceTypeOrDefaultSelector(state, ownProps),
  hasStickyNavbar: !ADV.util.env('isConsumerArea'),
  goalData: selectedGoalSelector(state, ownProps),
  isEstatePlanning2: isFeatureEnabled('EnableEstatePlanning', selectFeatureFlags(state, ownProps)),
});

const mapDispatchToProps = dispatch => ({
  resetView: (clientId, goalId) => {
    if (goalId && clientId) {
      dispatch(setCurrentViewId(clientId, goalId, null));
    }
  },
  resetModelPortfoliosGroups: clientId => dispatch(resetModelPortfoliosGroups(clientId)),
});

const WhatIfsContainer = connect(mapStateToProps, mapDispatchToProps)(View);

export default WhatIfsContainer;
